var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row mt-3"},[_c('DataTable',{attrs:{"tab":this.tab}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }